import { useLayoutEffect, useState } from "react";

export default function useOmsModalHeight(maxWidth = 1520) {
  const [content, setContent] = useState<HTMLDivElement | null>(null);
  const [title, setTitle] = useState<HTMLSpanElement | null>(null);
  const [footerContent, setFooterContent] = useState<HTMLDivElement | null>(
    null
  );
  const [height, setHeight] = useState<number>();
  const [width, setWidth] = useState<number>();
  useLayoutEffect(() => {
    if (!content || !title || !footerContent) return undefined;
    let frame = content.parentElement;
    while (frame && (!frame.contains(title) || !frame.contains(footerContent)))
      frame = frame.parentElement;
    if (!frame) return undefined;
    const container = frame;
    let header: HTMLElement = title;
    while (header.parentElement && header.parentElement !== frame)
      header = header.parentElement;
    const footer = footerContent.parentElement;
    if (!footer) return undefined;
    const body = content.parentElement;
    if (!body) return undefined;
    const update = () => {
      setWidth(Math.max(320, Math.min(maxWidth, window.innerWidth - 64)));
      // Measure padding directly: a constrained body no longer reflects its content height.
      const bodyStyle = window.getComputedStyle(body);
      const frameStyle = window.getComputedStyle(container);
      const pixels = (value: string) => parseFloat(value) || 0;
      const chrome =
        header.getBoundingClientRect().height +
        footer.getBoundingClientRect().height +
        pixels(bodyStyle.paddingTop) +
        pixels(bodyStyle.paddingBottom) +
        pixels(frameStyle.borderTopWidth) +
        pixels(frameStyle.borderBottomWidth);
      const available = Math.max(160, window.innerHeight - 32);
      setHeight(
        Math.ceil(content.getBoundingClientRect().height + chrome) > available
          ? available
          : undefined
      );
    };
    const observer =
      typeof ResizeObserver === "undefined"
        ? undefined
        : new ResizeObserver(update);
    [content, header, footer, body, container].forEach((element) =>
      observer?.observe(element)
    );
    update();
    window.addEventListener("resize", update);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [content, title, footerContent, maxWidth]);
  // The native modal portal mounts its slots after the parent layout effect.
  return {
    height,
    width,
    contentRef: setContent,
    titleRef: setTitle,
    footerRef: setFooterContent,
  };
}
